export default "__VITE_ASSET__CvKBLZYV__"